import Vue from "vue";
import VueRouter from "vue-router";

// Frontend Components
import Home from "@/components/Front/Home/Home.vue";
import SelectedServicePage from "@/components/Front/SelectedService/SelectedServicePage.vue";
import TokenPage from "@/components/Front/TokenPage/TokenPage.vue";
import Remainder from "@/components/Front/RemainderForm/Remainder.vue";

// Login Component
import Login from "@/components/Admin/Auth/Login.vue";

// Admin Components
import AdminHome from "@/components/Admin/AdminHome.vue";
import Dashboard from "@/components/Admin/Dashboard.vue";
import ServiceList from "../components/Admin/Service/ServiceList.vue";
import AddService from "@/components/Admin/Service/AddService.vue";
import EditService from "@/components/Admin/Service/EditService.vue";
import UserList from "../components/Admin/User/UserList.vue";
import AddUser from "@/components/Admin/User/AddUser.vue";
import EditUser from "@/components/Admin/User/EditUser.vue";
import AssignRoleTouser from "@/components/Admin/User/AssignRoleToUser.vue";
import AddRole from "@/components/Admin/Role/AddRole.vue";
import RoleList from "@/components/Admin/Role/RoleList.vue";
import EditRole from "@/components/Admin/Role/EditRole.vue";
import AssignPermissionToRole from "@/components/Admin/Role/AssignPermissionToRole.vue";
import SettingList from "@/components/Admin/Setting/List.vue";
import EditSetting from "@/components/Admin/Setting/Edit.vue";
import ReportByDate from "@/components/Admin/Report/ByDate.vue";
import ReportByDateRange from "@/components/Admin/Report/ByDateRange.vue";
import DeviceList from "@/components/Admin/Device/List.vue";
import AddDevice from "@/components/Admin/Device/Add.vue";
import EditDevice from "@/components/Admin/Device/Edit.vue";

// TV Screen
import DailyTokenTVScreen from "@/components/Admin/DailyTokenTVScreen.vue";

// Subscription
const SubscriptionList = () =>
  import("@/components/Admin/Subscription/Index.vue");

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
    meta: {
      guest: true,
    },
  },
  {
    path: "/selected-service/:slug",
    name: "SelectedServicePage",
    component: SelectedServicePage,
    meta: {
      guest: true,
    },
  },

  {
    path: "/remainder-form/:slug",
    name: "Remainder",
    component: Remainder,
    meta: {
      guest: true,
    },
  },
  {
    path: "/token",
    name: "TokenPage",
    component: TokenPage,
    // props: true
    meta: {
      guest: true,
    },
  },
  {
    path: "/admin/login",
    name: "Login",
    component: Login,
    meta: {
      guest: true,
    },
  },
  {
    path: "/admin/daily-token/tv-screen",
    name: "DailyTokenTVScreen",
    component: DailyTokenTVScreen,
  },
  {
    path: "/admin",
    name: "AdminHome",
    component: AdminHome,
    children: [
      {
        path: "",
        name: "Dashboard",
        component: Dashboard,
      },

      {
        path: "service",
        name: "ServiceList",
        component: ServiceList,
      },
      {
        path: "service/create",
        name: "AddService",
        component: AddService,
      },
      {
        path: "service/:id/edit",
        name: "EditService",
        component: EditService,
      },
      {
        path: "device",
        name: "DeviceList",
        component: DeviceList,
      },
      {
        path: "device/create",
        name: "AddDevice",
        component: AddDevice,
      },
      {
        path: "device/:id/edit",
        name: "EditDevice",
        component: EditDevice,
      },
      {
        path: "user",
        name: "UserList",
        component: UserList,
      },
      {
        path: "user/create",
        name: "AddUser",
        component: AddUser,
      },
      {
        path: "user/:id/edit",
        name: "EditUser",
        component: EditUser,
      },
      {
        path: "user/:id/assign-role",
        name: "AssignRoleTouser",
        component: AssignRoleTouser,
      },
      {
        path: "role",
        name: "RoleList",
        component: RoleList,
      },
      {
        path: "role/:id/edit",
        name: "EditRole",
        component: EditRole,
      },
      {
        path: "role/create",
        name: "AddRole",
        component: AddRole,
      },
      {
        path: "role/:id/assign-permission",
        name: "AssignPermissionToRole",
        component: AssignPermissionToRole,
      },
      {
        path: "setting",
        name: "SettingList",
        component: SettingList,
      },
      {
        path: "setting/:id/edit",
        name: "EditSetting",
        component: EditSetting,
      },
      {
        path: "report/by-date",
        name: "ReportByDate",
        component: ReportByDate,
      },
      {
        path: "report/by-date-range",
        name: "ReportByDateRange",
        component: ReportByDateRange,
      },
      // subscription
      {
        path: "subscription",
        component: SubscriptionList,
        name: "SubscriptionList",
      },
    ],
  },
  {
    path: "/:pathMatch(.*)*",
    redirect: () => {
      const token = sessionStorage.getItem("token");

      // If user is logged in → send to admin dashboard
      if (token) {
        return "/admin";
      }

      // If not logged in → send to login
      return "/admin/login";
    },
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  console.log("Navigating to:", to.name);
  if (to.meta.guest) {
    next();
  } else {
    if (!sessionStorage.getItem("token")) {
      // this.$router.push({ name: "Login" });
      window.location = "/admin/login";
    } else {
      next();
    }
  }
});
export default router;
